import { z } from "zod";

export const CountryReportFilterSchemaV4 = z.object({
    property_id: z.string(),
    base_on: z.enum(["created_reservation", "checkin_date"]),
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export type CountryReportFilterV4Type = z.infer<typeof CountryReportFilterSchemaV4>;